import * as React from 'react';
import { WritingSectionAnswerState } from './states/WritingSectionAnswerState';
import { WritingQuestionType } from '../../../../commonv3/types/writingQuestions';
import { MultiSelectQuestionView, SingleSelectQuestionView } from '../writing_questions/WritingQuestionView';
import './examWritingSectionView.module.scss';
import { action, observable, computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@sheinc/shelikes-design-system';

const SectionHeader = ({ title }) => (
  <div styleName="section-header-wrapper">
    <div styleName="section-header">CHECKTEST</div>
    <div styleName="section-title">{title}</div>
  </div>
);

const SectionBody = ({ children }) => (
  <div styleName="section-body-wrapper">
    <div styleName="section-body">{children}</div>
  </div>
);

const StartExamView = ({ questionsCount, onClick, submitting = false }) => (
  <div styleName="start-exam-view">
    <div styleName="total">全{questionsCount}問</div>
    <div styleName="text1">筆記試験で</div>
    <div styleName="text2">コースの理解度を試そう</div>
    <Button id="start-exam-button" isLoading={submitting} onClick={onClick}>
      テストをはじめる
    </Button>
  </div>
);

const SectionBodyInner = ({
  startScreen,
  questions,
  index,
  nextOrSubmit,
  lastQuestion,
  answerState,
  startExam,
  submitting,
}) => {
  if (startScreen) {
    return <StartExamView questionsCount={questions.length} onClick={startExam} />;
  } else {
    const question = questions[index];
    switch (question.question_type) {
      case WritingQuestionType.SINGLE_SELECT:
        return (
          <SingleSelectQuestionView
            index={index + 1}
            question={question}
            answerState={answerState.getSingleSelectAnswerState(question)}
            showAnswer={false}
            onNextClick={nextOrSubmit}
            submitting={submitting}
            lastQuestion={lastQuestion}
          />
        );
      case WritingQuestionType.MULTI_SELECT:
        return (
          <MultiSelectQuestionView
            index={index + 1}
            question={question}
            answerState={answerState.getMultiSelectAnswerState(question)}
            showAnswer={false}
            onNextClick={nextOrSubmit}
            submitting={submitting}
            lastQuestion={lastQuestion}
          />
        );
    }
  }
};

const SectionFooter = ({ children }) => (
  <div styleName="section-footer-wrapper">
    <div styleName="section-footer">{children}</div>
  </div>
);

type Props = {
  answerState: WritingSectionAnswerState;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: () => any;
  submitting?: boolean;
  title: string;
};

export const ExamWritingSectionView = observer(
  class ExamWritingSectionView extends React.Component<Props> {
    currentIndex = 0;
    startScreen = true;

    constructor(props: Props) {
      super(props);

      makeObservable(this, {
        currentIndex: observable,
        startScreen: observable,
        nextOrSubmit: action.bound,
        lastQuestion: computed,
      });
    }

    nextOrSubmit() {
      if (this.lastQuestion) {
        this.props.onSubmit();
      } else {
        this.currentIndex++;
      }
    }
    startExam = () => {
      this.startScreen = false;
    };
    previousQuestion = () => {
      this.currentIndex--;
    };
    get lastQuestion() {
      return this.currentIndex === this.props.answerState.questions.length - 1;
    }

    render() {
      const { title, answerState, submitting = false } = this.props;
      const { questions } = answerState;

      return (
        <div styleName="view">
          <SectionHeader title={title} />
          <SectionBody>
            <SectionBodyInner
              startScreen={this.startScreen}
              questions={questions}
              index={this.currentIndex}
              nextOrSubmit={this.nextOrSubmit}
              lastQuestion={this.lastQuestion}
              answerState={answerState}
              startExam={this.startExam}
              submitting={submitting}
            />
          </SectionBody>
          <SectionFooter>
            {this.currentIndex > 0 && (
              <Button
                variant="secondary"
                size="small"
                chevron="left"
                isLoading={submitting}
                onClick={this.previousQuestion}
              >
                前の問題に戻る
              </Button>
            )}
          </SectionFooter>
        </div>
      );
    }
  }
);
